export function langBanner() {
  let cookieLang = "";
  let ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) == ' ') { c = c.substring(1) }
    if (c.indexOf("lang=") == 0) { cookieLang = c.substring("lang=".length, c.length) }
  }
  if (!cookieLang) {
    const langmessages = {
      en: ["Do you want to read it in English?", "Change to English", "No, thanks"],
      it: ["Vuoi leggerlo in italiano?", "Passa all'italiano", "No, grazie"],
    }
    let userLang = navigator.language || navigator.userLanguage;
    userLang = userLang.slice(0, 2);
    if (userLang !== "it") { userLang = "en" }
    console.log(userLang)
    let switchNode = document.querySelector('footer .wpml-ls-item-' + userLang + ':not(.wpml-ls-current-language) a');
    if (switchNode) {
      var switchLink = switchNode.href;
      document.body.insertAdjacentHTML('beforeend', '<aside class="lang-switcher"><a href="#">&times;</a><h4><strong>' + langmessages[userLang][0] + '</strong></h4><a class="cta cta--mini" href="' + switchLink + '">' + langmessages[userLang][1] + '</a> <a class="cta cta--mini cta--secondary" href="#">' + langmessages[userLang][2] + '</a></aside>');
      [].forEach.call(document.querySelectorAll('aside a'), function (el) {
        el.addEventListener("click", function (el) {
          if (el.currentTarget.href.includes("#")) {
            el.preventDefault();
            let d = new Date();
            d.setTime(d.getTime() + (5184000000));
            let expires = "expires=" + d.toUTCString();
            document.cookie = "lang=" + userLang + ";" + expires + ";path=/";
            document.querySelector('.lang-switcher').style.display = 'none';
          }
        });
      })
    }
  }
}
